<div class="dialog-content">
  <p  class="dialog-content__msg">{{ config.data.message | translate  }}</p>
</div>

<div class="footer">
  <button class="footer__btn footer__btn--reject" (click)="reject()">{{ config.data.rejectLabel | translate }}</button>
  <button class="footer__btn footer__btn--accept" [ngStyle]="{'background-color': config.data.acceptLabelColor}"
          (click)="accept()">{{ config.data.acceptLabel | translate }}</button>
</div>
